import type { ReactNode } from 'react';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3155, { U3155ROLES } from './U3155';
import U3155MinutesWorkNatureList from './components/U3155MinutesWorkNatureList';
import U3155MinutesWorkNatureForm from './components/U3155MinutesWorkNatureForm';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3155Routes: RouteObject[] = [
  {
    path: 'U3155',
    element: <U2000RequireRole allowedRoles={[U3155ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3155 />,
        children: [
          { index: true, element: <U3155MinutesWorkNatureList /> },
          { path: ':id', element: <U3155MinutesWorkNatureForm /> },
        ],
      },
    ],
  },
];

export default U3155Routes;
